import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * `/admin` on the orca portal host is not an orca route (it is the admin-console
 * path on the other brands, so it arrives as typed URLs, bookmarks and the login
 * door's `redirect_url`). This static route catches it under the `/orca` wildcard
 * rewrite and sends the operator to Runners.
 *
 * @since 1.0.0
 */
export const Route = createFileRoute("/orca/admin")({
  beforeLoad: () => {
    throw redirect({ to: "/orca/runners" });
  },
});
